var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-badge',{attrs:{"variant":_vm.workareaStatus.color},domProps:{"innerHTML":_vm._s(_vm.showNumber ? _vm.order.salesOrderNumber : _vm.workareaStatus.badge)}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52734e2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/node_modules/vue-loader/lib/selector.js?type=template&index=0!/src/components/utility/WorkareaStatus.vue
// module id = null
// module chunks = 